'use client';
const IDENT = 'BaseButton';
const defaultProps = {
    type: 'button',
    contentGap: '2s'
};

export { IDENT, defaultProps };
//# sourceMappingURL=BaseButton.contract.js.map
